var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('img',{staticClass:"official-tag",class:'official-tag--' + _vm.size,attrs:{"src":_vm.tagSrc,"alt":"官方人员","title":"官方人员"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }